import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import ButtonWithLoader from 'core/components/button-with-loader'

const Wrapper = styled.div`
  margin: auto;
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: center;
  width: fit-content;

  .info {
    margin-bottom: 4px;
  }
`

const CustomLazyLoad = ({ canLoadMore, dataElementSuffix, loadMore, infoText, isLoading }) => {
  return <Wrapper>
    <div className='info'>
      <div className='info-text'>
        {infoText}
      </div>
    </div>
    <ButtonWithLoader
      dataElementSuffix={`custom-pagination--${dataElementSuffix}`}
      disabled={!canLoadMore || isLoading}
      showLoader={isLoading}
      onClick={loadMore}
      text='Load more'
      />
  </Wrapper>
}

CustomLazyLoad.propTypes = {
  canLoadMore: PropTypes.bool,
  dataElementSuffix: PropTypes.string.isRequired,
  loadMore: PropTypes.func,
  infoText: PropTypes.string,
  isLoading: PropTypes.bool
}

export default CustomLazyLoad
